module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 305
// module chunks = 1